import { mapValues, set, omit } from "lodash-es"
import dayjs from "dayjs"
import { useSelector } from "react-redux"

export const PAGE_SIZE = 15
const INTIAL_STATE: any = {
  selectedDate: dayjs().format("YYYY-MM-DD"),
  selectedTab: "all",
  isFilterOpen: true,
  isSummaryOpen: false,
  search: "",
  page: 0,
  // Store the map zoom as a global state to preserve it while routing
  map: {
    center: { lat: 20.230377, lng: 73.7851083 },
    zoom: 15,
  },
  filter: {
    status: {
      OT: false,
      CP: false,
      DS: false,
      NS: false,
      PS: false,
      IL: false,
    },
    skuRange: {
      range1: {
        selected: false,
        value: [25, 50],
      },
      range2: {
        selected: false,
        value: [125, 150],
      },
      range3: {
        selected: false,
        value: [225, 275],
      },
    },
    varieties: [],
    tripCount: {},
  },
}

// Filter Actions
export const VEHICLE_CHANGE_DATE = "VEHICLE_CHANGE_DATE"
export const VEHICLE_CHANGE_SELECTED_TAB = "VEHICLE_CHANGE_SELECTED_TAB"
export const VEHICLE_CLOSE_FILTER = "VEHICLE_CLOSE_FILTER"
export const VEHICLE_OPEN_FILTER = "VEHICLE_OPEN_FILTER"
export const VEHICLE_TOGGLE_FILTER = "VEHICLE_TOGGLE_FILTER"
export const VEHICLE_CHANGE_FILTER = "VEHICLE_CHANGE_FILTER"
export const VEHICLE_CHANGE_RANGE = "VEHICLE_CHANGE_RANGE"
export const VEHICLE_TOGGLE_SINGLE = "VEHICLE_TOGGLE_SINGLE"
export const VEHICLE_TOGGLE_EXPAND = "VEHICLE_TOGGLE_EXPAND"
export const VEHICLE_CHANGE_SEARCH = "VEHICLE_CHANGE_SEARCH"
export const VEHICLE_CHANGE_PAGE = "VEHICLE_CHANGE_PAGE"
// Change Status Filter
export const VEHICLE_TOGGLE_STATUS = "VEHICLE_TOGGLE_STATUS"
// Toggle Node
export const VEHICLE_TOGGLE_NODE = "VEHICLE_TOGGLE_NODE"
export const VEHICLE_TOGGLE_SKU_RANGE = "VEHICLE_TOGGLE_SKU_RANGE"
export const VEHICLE_TOGGLE_SELECT_ALL = "VEHICLE_TOGGLE_SELECT_ALL"
// Summary Drawer
export const VEHICLE_TOGGLE_SUMMARY = "VEHICLE_TOGGLE_SUMMARY"
export const VEHICLE_CLOSE_SUMMARY = "VEHICLE_CLOSE_SUMMARY"
export const VEHICLE_CHANGE_ACTIVE_FILTERS = "VEHICLE_CHANGE_ACTIVE_FILTERS"

// Vehicle Map
export const VEHICLE_CHANGE_MAP_CENTER = "VEHICLE_CHANGE_MAP_CENTER"
export const VEHICLE_CHANGE_MAP_ZOOM = "VEHICLE_CHANGE_MAP_ZOOM"

// Select Filters
export const VEHICLE_CHANGE_VARIETIES = "VEHICLE_CHANGE_VARIETIES"

export const VEHICLE_SELECT_PLOT_COMMODITY = "VEHICLE_SELECT_PLOT_COMMODITY"
export const VEHICLE_ADD_RECOMMENDATION_ROUTE =
  "VEHICLE_ADD_RECOMMENDATION_ROUTE"
export const VEHICLE_REMOVE_RECOMMENDATION_ROUTE =
  "VEHICLE_REMOVE_RECOMMENDATION_ROUTE"
export const vehicleReducer = (state = INTIAL_STATE, { type, payload }) => {
  switch (type) {
    case VEHICLE_CHANGE_DATE:
      return {
        ...state,
        selectedDate: dayjs(payload).format("YYYY-MM-DD"),
      }
    case VEHICLE_CHANGE_SELECTED_TAB:
      return {
        ...state,
        selectedTab: payload,
      }
    case VEHICLE_OPEN_FILTER:
      return {
        ...state,
        isFilterOpen: true,
      }
    case VEHICLE_TOGGLE_FILTER:
      return {
        ...state,
        isFilterOpen: !state.isFilterOpen,
      }
    case VEHICLE_CLOSE_FILTER:
      return {
        ...state,
        isFilterOpen: false,
      }
    case VEHICLE_TOGGLE_STATUS:
      return {
        ...state,
        filter: {
          ...state.filter,
          status: {
            ...state.filter.status,
            [payload.status]: state.filter.status[payload.status]
              ? false
              : true,
          },
        },
      }
    case VEHICLE_TOGGLE_NODE:
      return {
        ...state,
        filter: {
          ...state.filter,
          status: {
            ...state.filter.status,
            [payload.id]: !state.filter.status[payload.id],
          },
        },
      }
    case VEHICLE_TOGGLE_SINGLE:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload.filterType]: {
            [payload.id]: !state.filter[payload.filterType][payload.id],
          },
        },
      }
    case VEHICLE_TOGGLE_SELECT_ALL:
      return {
        ...state,
        filter: {
          ...state.filter,
          varieties: {
            selectAll: !state.filter.varieties.selectAll,
            values: state.filter.varieties.selectAll
              ? {}
              : payload.reduce((prev, current) => {
                  return set(prev, current.id, true)
                }, {}),
          },
        },
      }

    case VEHICLE_TOGGLE_SKU_RANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          skuRange: mapValues(state.filter.skuRange, (value, key) => {
            return {
              ...value,
              selected: key === payload ? !value.selected : value.selected,
            }
          }),
        },
      }
    case VEHICLE_CHANGE_RANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          skuRange: {
            ...state.filter.skuRange,
            [payload.id]: {
              selected: state.filter.skuRange[payload.id].selected,
              value: payload.value,
            },
          },
        },
      }
    case VEHICLE_TOGGLE_SUMMARY:
      return {
        ...state,
        isSummaryOpen: !state.isSummaryOpen,
      }

    case VEHICLE_CHANGE_SEARCH:
      return {
        ...state,
        search: payload,
        page: 0,
      }

    case VEHICLE_CHANGE_PAGE:
      return {
        ...state,
        page: payload,
      }
    case VEHICLE_CHANGE_VARIETIES:
      return {
        ...state,
        filter: {
          ...state.filter,
          varieties: payload,
        },
      }
    case VEHICLE_CHANGE_MAP_CENTER:
      return {
        ...state,
        map: {
          ...state.map,
          center: payload,
        },
      }

    case VEHICLE_CHANGE_MAP_ZOOM:
      return {
        ...state,
        map: {
          ...state.map,
          zoom: payload,
        },
      }

    case VEHICLE_SELECT_PLOT_COMMODITY:
      return {
        ...state,
        plotCommodity: payload,
      }

    case VEHICLE_ADD_RECOMMENDATION_ROUTE:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          [payload.id]: {
            routes: payload.routes,
          },
        },
      }
    case VEHICLE_REMOVE_RECOMMENDATION_ROUTE:
      return {
        ...state,
        recommendations: omit(
          {
            ...state.recommendations,
          },
          [payload]
        ),
      }
    case VEHICLE_CLOSE_SUMMARY:
      return {
        ...state,
        isSummaryOpen: false,
      }
    default:
      return state
  }
}

export function useVehicleSelector(path) {
  return useSelector((state: any) => state.vehicle[path])
}
// Faremr
export function useStatusFilter() {
  const status = useSelector((state: any) => state.vehicle.filter.status)
  return Object.keys(status).filter(s => status[s])
}
